import { el } from 'redom';

import SearchResultsList from './search-results-list';

class RecentSearchesDisplay {

  constructor() {

    this.onClick = null;

    this.el = el('.recent-searches-display');

  }

  setOnClick(onClick) {

    this.onClick = onClick;

  }

  update(groups) {

    this.el.innerHTML = '';

    const hasResults = groups.today.length > 0 || groups.pastWeek.length > 0 || groups.pastMonth.length > 0;

    if (hasResults === false) {
      return false;
    }

    if (groups.today.length > 0) {
      const todaySection = this.createSection('Today', groups.today);
      this.el.appendChild(todaySection);
    }

    if (groups.pastWeek.length > 0) {
      const pastWeekSection = this.createSection('Past Week', groups.pastWeek);
      this.el.appendChild(pastWeekSection);
    }

    if (groups.pastMonth.length > 0) {
      const pastMonthSection = this.createSection('Past Month', groups.pastMonth);
      this.el.appendChild(pastMonthSection);
    }

    return true;

  }

  createSection(label, searches) {

    const sectionLabel = el('.recent-searches-section-label', label);

    const resultsList = new SearchResultsList();
    resultsList.setOnClick(this.onClick);

    resultsList.update(searches);

    const section = el('.recent-searches-section', [
      sectionLabel,
      resultsList.el
    ]);

    return section;

  }

}

export default RecentSearchesDisplay;
